import { game } from '../main';
import { detachOnDestroy } from '../utils/detachOnDestroy';
import { Popup } from './Popup';

export class WindowLayer extends Phaser.Group {
  private queue: Array<() => Popup> = [];

  constructor() {
    super(game);
    this.fixedToCamera = true;

    detachOnDestroy(this, game.signals.onScreenResize.add(this.onResize));

    // G.sb('pushWindow').add(this.pushWindow, this);
    // G.sb('onWindowClosed').add(this.onWindowClosed, this);
    // G.sb('onWindowOpened').add(this.cacheWindow, this);
  }

  public isEmpty(): boolean {
    return this.children.length === 0;
  }

  public onResize = () => {
    this.cameraOffset.setTo(
      Math.floor(game.width * 0.5),
      Math.floor(game.height * 0.5),
    );
  }

  public pushWindow = (creationFunc: () => Popup) => {
    if (this.queue.length === 0 && this.children.length === 0) {
      const popup = creationFunc();
      this.addChild(popup);
      popup.onDestroy.addOnce(() => this.onWindowClosed);
    } else {
      this.queue.push(creationFunc);
    }
  }

  private onWindowClosed(): void {
    if (this.queue.length > 0) {
      const popup = (this.queue.shift() as () => Popup)();
      this.addChild(popup);
      popup.onDestroy.addOnce(() => this.onWindowClosed);
    } else {
      // G.sb('onAllWindowsClosed').dispatch();
    }
  }
}